import { GaletBase } from '@app/baseBtl/catalog/products/equipement/complex/galet';

export class Galet extends GaletBase {}
